import React from 'react';
import styled from 'styled-components';
import { Button } from 'components/Button';

import logoImg from 'assets/images/logo.svg';

const Container = styled.div`
	width: 100%;
	height: 6.25rem;
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 0 5rem;
	box-sizing: border-box;

	${({ theme }) => theme.mediaWidth.upToSmall`
    padding: 0 1rem;
  `}
`;

const LogoImg = styled.img`
	height: 3rem;
`;

export const Header = () => {
	return (
		<Container>
			<a target="script3" href="https://script3.io/">
				<LogoImg src={logoImg} alt="" />
			</a>
			<Button variant="secondary" onClick={() => window.open('https://script3.io/scriptees-help', 'help')}>
				Support
			</Button>
		</Container>
	);
};
